module.exports = __webpack_public_path__ + "assets/media/m-3.0c6575f3.svg";